const BulkActionModule = 'bulkAction';
const CustomerModule = 'customer';
const CampaignModule = 'campaign';
const PageHeaderModule = 'pageHeader';
const RuleModule = 'rule';
const RewardModule = 'reward';
const GlobalModule = 'global';
const MicrositeModule = 'microsite';
const IntelligenceModule = 'intelligence';
const OrbitModule = 'orbit';

export {
  BulkActionModule,
  CustomerModule,
  CampaignModule,
  PageHeaderModule,
  RuleModule,
  RewardModule,
  GlobalModule,
  MicrositeModule,
  IntelligenceModule,
  OrbitModule
};
